<dx-popup
    class="popup-info"
    [width]="popupWidth"
    height="auto"
    [showTitle]="true"
    titleTemplate="title"
    [dragEnabled]="true"
    [showCloseButton]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="isShowPopupMessage"
    (onHidden)="hide()"
>
    <div *dxTemplate="let data of 'content'">
        <div [innerHTML]="popupMessageContent"></div>
        <div style="margin-top: 15px; float: right; padding-right: 10px; padding-bottom: 10px;">
            <dx-button type="default" text="Close" (click)="btnCloseClick()"></dx-button>
        </div>
    </div>
    <div *dxTemplate="let data of 'title'">
        <span [innerHTML]="headerIcon"></span>
        {{ popupMessageTitle }}
    </div>
</dx-popup>
